import React, { useEffect, useState, useCallback } from 'react';

// eBay image URLs always end in s-l<NNN>.jpg — swap the size to get any
// available variant from the same image. 1600 is the largest commonly served.
export function resizeEbayUrl(url, size) {
  if (!url) return url;
  return url.replace(/s-l\d+\.jpg/i, `s-l${size}.jpg`);
}

export function parseImageList(jsonStr) {
  try {
    const arr = JSON.parse(jsonStr || '[]');
    return Array.isArray(arr) ? arr.filter(Boolean) : [];
  } catch { return []; }
}

export default function ImageLightbox({ images, startIndex = 0, onClose }) {
  const [idx, setIdx] = useState(startIndex);
  const total = images.length;

  const next = useCallback(() => setIdx(i => (i + 1) % total), [total]);
  const prev = useCallback(() => setIdx(i => (i - 1 + total) % total), [total]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [next, prev, onClose]);

  if (!total) return null;
  const current = resizeEbayUrl(images[idx], 1600);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.92)', zIndex: 3000,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div style={{ position: 'absolute', top: 16, right: 20, color: '#fff', fontSize: 14, opacity: 0.7 }}>
        {idx + 1} / {total}
      </div>
      <button
        onClick={e => { e.stopPropagation(); onClose(); }}
        style={{
          position: 'absolute', top: 12, left: 16, background: 'transparent', border: 'none',
          color: '#fff', fontSize: 28, cursor: 'pointer', padding: 8,
        }}
        aria-label="Close"
      >✕</button>

      {total > 1 && (
        <button
          onClick={e => { e.stopPropagation(); prev(); }}
          style={{
            position: 'absolute', left: 20, top: '50%', transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,.1)', color: '#fff', border: 'none',
            width: 48, height: 48, borderRadius: '50%', fontSize: 24, cursor: 'pointer',
          }}
          aria-label="Previous"
        >‹</button>
      )}

      <img
        src={current}
        alt=""
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '92vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: 6 }}
      />

      {total > 1 && (
        <button
          onClick={e => { e.stopPropagation(); next(); }}
          style={{
            position: 'absolute', right: 20, top: '50%', transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,.1)', color: '#fff', border: 'none',
            width: 48, height: 48, borderRadius: '50%', fontSize: 24, cursor: 'pointer',
          }}
          aria-label="Next"
        >›</button>
      )}

      {total > 1 && (
        <div
          onClick={e => e.stopPropagation()}
          style={{
            position: 'absolute', bottom: 20, display: 'flex', gap: 6,
            padding: '8px 12px', background: 'rgba(0,0,0,.5)', borderRadius: 8,
            maxWidth: '90vw', overflowX: 'auto',
          }}
        >
          {images.map((u, i) => (
            <img
              key={i}
              src={resizeEbayUrl(u, 140)}
              alt=""
              onClick={() => setIdx(i)}
              style={{
                width: 56, height: 56, objectFit: 'cover', borderRadius: 4, cursor: 'pointer',
                border: i === idx ? '2px solid #fff' : '2px solid transparent', flexShrink: 0,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
